/** @format */

export enum CalculationType {
  PROPOSED = 'PROPOSED',
  UNAPPROVED = 'UNAPPROVED',
  HARD = 'HARD',
  SOFT = 'SOFT',
}
